import http from '@/requests/http'
import appConfig from '@/config/app'

class AgentInboundDetailsReport {
  static findAll (params) {
    return http.post('agents/inbound-details/reports/index', params)
  }
  static async export (params) {
    const URLparams = new URLSearchParams(Object.entries(params))
    window.open(`${appConfig.apiBaseUrl  }/agents/inbound-details/reports/export?${URLparams}`, '_blank')
  }
}

export default AgentInboundDetailsReport
